import { useEffect, useState } from "react";
import { auth } from "../firebase";
import { useNavigate, useLocation } from "react-router-dom";
import { signInWithEmailLink, updatePassword } from "firebase/auth";
import { getAuthErrorMessage } from "../utils/authErrors";

export default function AdminCompleteSignup() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // 1. Get email from query OR prompt user (ideally email comes in link)
    const params = new URLSearchParams(location.search);
    const emailFromUrl = params.get("email");
    if (emailFromUrl) setEmail(emailFromUrl);
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!email) {
      setError("Missing email. Please check your invitation link.");
      return;
    }
    if (!password || !confirm) {
      setError("Please fill all password fields.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      // 2. Complete sign-in via email link
      await signInWithEmailLink(auth, email, window.location.href);

      // 3. Set password
      await updatePassword(auth.currentUser, password);

      setSuccess("Password set! Your admin account is now active.");
      setTimeout(() => {
        navigate("/login");
      }, 1500);
    } catch (err) {
      setError(getAuthErrorMessage(err, "completeSignup"));
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 to-purple-100">
      <div className="bg-white p-8 rounded-xl shadow-xl w-full max-w-md">
        <h2 className="text-2xl font-bold text-blue-700 mb-4">
          Set Your Admin Password
        </h2>
        {error && <div className="text-red-500 mb-2">{error}</div>}
        {success && <div className="text-green-600 mb-2">{success}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            className="w-full px-4 py-2 border rounded-lg"
            type="email"
            placeholder="Email"
            value={email}
            disabled
            required
          />
          <input
            className="w-full px-4 py-2 border rounded-lg"
            type="password"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <input
            className="w-full px-4 py-2 border rounded-lg"
            type="password"
            placeholder="Confirm Password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
          <button
            type="submit"
            className="w-full py-2 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700"
            disabled={loading}
          >
            {loading ? "Setting Password..." : "Set Password"}
          </button>
        </form>
      </div>
    </div>
  );
}
